import React from "react";
import '../../../styles/component/common/empty-data.scss';

interface emptyDataProps {
    icon: React.ReactNode;
    title: string;
    subtitle?: string;
    button?: React.ReactNode;
    onClick?: () => void;
}

const EmptyData = ({icon, title, subtitle, button, onClick}: emptyDataProps) => {

    return (
        <div className={'empty-data-container'} onClick={onClick}>
            <div className={'empty-data-icon'}>
                {icon}
            </div>
            <div className={'empty-data-title'}>
                {title}
            </div>
            <div className={'empty-data-sub-title'}>
                {subtitle}
            </div>
            {
                button && <div className={'empty-data-button-wrapper'}>
                    {button}
                </div>
            }

        </div>
    )
}

export default EmptyData;
